import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.13.0_next@15.5.19_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7__s77zxnvsiifnxlxdly3jg73cnu/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.13.0_next@15.5.19_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7__s77zxnvsiifnxlxdly3jg73cnu/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["AvailableServices"] */ "/app/src/app/[locale]/_components/available-services.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EasyToUse"] */ "/app/src/app/[locale]/_components/easy-to-use.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/app/[locale]/_components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/app/[locale]/_components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Jumbotron"] */ "/app/src/app/[locale]/_components/jumbotron.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextGeneration"] */ "/app/src/app/[locale]/_components/next-generation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoCommission"] */ "/app/src/app/[locale]/_components/no-commission.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OneService"] */ "/app/src/app/[locale]/_components/one-service.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SendAndReceive"] */ "/app/src/app/[locale]/_components/send-and-receive.tsx");
